import {cartApproverMessageStyles} from "@insite/content-library/Widgets/Common/CartApproverMessage"
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design"
import { css } from "styled-components"

cartApproverMessageStyles.approvingWrapper= {
    css: css`
        text-align: center;
        padding: 10px;
        background: linear-gradient(90deg, #266B40 27.08%, #2D804C 71.87%, #43687A 100%);
    `,
}

cartApproverMessageStyles.approvingText = {
    css: css`
        width: 100%;
        color: ${COLORS.white} !important;
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
    `,
}